import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from "@angular/material/dialog";
import { PowerSupplyService } from '@psnb/services';
import { CommonService } from '../../../common/common.service';
import { PowerSupplyMessageDialog } from '../../../common/message-dialog/power-supply-message-dialog';

@Component({
    selector: 'edit-self-test-duration-renderer',
    templateUrl: './edit-test-duration-renderer.component.html'
})
export class EditTestDurationRendererComponent implements OnInit {
    testDurationForm: any;
    notSuccess: boolean = false;
    showProgressBar:boolean = false;
    //showMsg:boolean = false;
    defaultConfigVal: number = 12;
    adminTestConfigMaxVal: number = 125;
    isAdmin: boolean = false;
    maxVal:number;
    adminMaxValidate:boolean = false;
    nonAdminMaxValidate: boolean = false;
    private powerSupplyMessageDialog: MatDialogRef<PowerSupplyMessageDialog>;
    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<EditTestDurationRendererComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private powerSupplyService: PowerSupplyService,
        private dialog: MatDialog,
        private commonService : CommonService) {
    }

    ngOnInit() {
        if (this.commonService.checkAdminPermission()) {
            this.maxVal = this.adminTestConfigMaxVal;
            this.isAdmin = true;
        } else {
            this.maxVal = this.defaultConfigVal;
        }
        this.testDurationForm = this.fb.group({
            testDuration: [this.defaultConfigVal, Validators.required]
        });
    }

    submit(form) {
        this.notSuccess = false;
        //this.showMsg = false;
        if (this.isAdmin) {
            if (form.value.testDuration > this.adminTestConfigMaxVal ||
                form.value.testDuration < 0) {
                this.adminMaxValidate = true;
            }
            else {
                this.commonMethod(form);
            }
        } else if (!this.isAdmin) {
            if (form.value.testDuration > this.defaultConfigVal ||
                form.value.testDuration < 0) {
                this.nonAdminMaxValidate = true;
            }
            else {
                this.commonMethod(form);
            }
        }
    }

    /*
   * Self test success message diplay dialog
   */
  openMessageDialog(message: string) {
    this.powerSupplyMessageDialog = this.dialog.open(PowerSupplyMessageDialog, {
      data: {
        message: message ? message : ''
      }
    })
  }

    commonMethod(form) {
        this.showProgressBar = true;
        this.adminMaxValidate = false;
        this.nonAdminMaxValidate = false;
        this.powerSupplyService.setTestDurationByMac(this.data.macAddress, form.value.testDuration).subscribe(result => {
            if (result.success === true) {
                this.showProgressBar = false;
                //this.showMsg = true;
                this.openMessageDialog('Test Duration updated to '+ form.value.testDuration + 'minutes and will be reflected in Telemetry Page View after 1 hour.');
                this.dialogRef.close(true);
                // setTimeout(() => {
                //     this.dialogRef.close(true);
                //   }, 3000);
            } else {
                this.showProgressBar = false;
                this.notSuccess = true;
            }
        }, err => {
            this.showProgressBar = false;
            this.notSuccess = true;
        });
    }
}
